export default __webpack_public_path__ + "static/media/invite-instructor.c0f408ae.png";